import { addNewMessages } from "../../slices/messageSlice";
import { hydrateMessageArray } from "../../utils/messageUtils";

//fetches new messages and adds them to pagination results (first page).
export const fetchNewMessages = (practitionerId, fhirClient, direction) => {
    //console.log("🔄 Starting fetchNewMessages for practitionerId:", practitionerId, "direction:", direction);

    return async (dispatch, getState) => {
        if (!practitionerId || !fhirClient || !direction) {
            console.warn("⚠️ Missing required parameters for fetchNewMessages");
            return;
        }

        try {
            const state = getState().messages;
            const participantParam = direction === "sent" ? "sender" : "recipient";

            // ✅ Use currentPageUrl from Redux instead of queryKey
            const currentPageUrl = state.currentPageUrl;

            // If no currentPageUrl, fall back to initial query
            const queryUrl = currentPageUrl || `Communication?${participantParam}=Practitioner/${practitionerId}&_count=10&_sort=-sent&sent=ge1900-01-01`;

            const existingPage = state.pageMap[currentPageUrl];
            const existingIds = existingPage?.ids || [];

            const existingMessages = existingIds
                .map(id => state.byId[id])
                .filter(Boolean);

            const response = await fhirClient.request(queryUrl);
            const rawMessages = (response.entry || []).map(e => e.resource);

            if (rawMessages.length === 0) {
                console.log("📭 No messages found");
                return;
            }

            const newMessages = rawMessages.filter(msg => !existingIds.includes(msg.id));

            if (newMessages.length === 0) {
                //console.log("🧼 All messages already displayed");
                return;
            }

            console.log(`🆕 Found ${newMessages.length} new messages. Hydrating...`);

            const hydratedMessages = await hydrateMessageArray({
                messages: newMessages,
                contextProvider: { id: practitionerId },
                store: getState,
                fhirClient,
                dispatch,
                isMounted: true
            });

            if (!hydratedMessages || hydratedMessages.length === 0) {
                console.log("⚠️ Hydration returned no usable messages");
                return;
            }

            const combinedMessages = [...hydratedMessages, ...existingMessages];
            const updatedIds = [...hydratedMessages.map(m => m.id), ...existingIds];

           /*
            dispatch(setPageMessages({
                pageUrl: currentPageUrl,
                messages: combinedMessages,
                nextPageUrl: existingPage?.nextPageUrl || null,
                prevPageUrl: existingPage?.prevPageUrl || null,
                total: updatedIds.length
            }));
*/
             dispatch(addNewMessages(hydratedMessages));
        } catch (err) {
            console.error("💥 fetchNewMessages failed:", err);
        }
    };
};